/* eslint-disable */
import type {FC} from 'react';
import React, {useEffect, useRef, useState} from 'react';
import {Alert, Box, Button, CircularProgress, Collapse, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Typography} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import useIndicators from 'src/hooks/useIndicators';
import useAuth from 'src/hooks/useAuth';
import useIsMountedRef from '../../hooks/useIsMountedRef';
import DatePicker, {registerLocale} from "react-datepicker";
import es from "date-fns/locale/es";
registerLocale("es",es);
import {useStyles} from 'src/components/dashboard/style';
import 'react-datepicker/dist/react-datepicker.css'
import WidgetBalance from 'src/components/dashboard/overview/masterOverview/ComponentesPrior/WidgetBalance';
import TablaFinanciera from 'src/components/dashboard/overview/masterOverview/Tablas/TablaFinanciera';
import WidgeTwoColumns from 'src/components/dashboard/overview/masterOverview/ComponentesPrior/WidgeTwoColumns';
import ChartUtilidadNeta from 'src/components/dashboard/overview/masterOverview/Charts/ChartUtilidadNeta';
import {getZazacorpPrediction} from 'src/components/bridges/BridgeBusiness';
import TotalSalesIncome from "../../components/dashboard/overview/masterOverview/ComponentesPrior/TotalSalesIncome";
import TablaFinSmall from "../../components/dashboard/overview/masterOverview/Tablas/TablaFinSmall";
import {addDays} from 'date-fns';
import ChartUtilidades from "../../components/dashboard/overview/masterOverview/Charts/ChartUtilidades";
import UtilitiesRadialBars from "../../components/dashboard/overview/masterOverview/Charts/UtilitiesRadialBars";
import BarDonutER from "../../components/dashboard/overview/masterOverview/Charts/BarDonutER";
import AssessmentIcon from "@material-ui/icons/Assessment";
import viewMoreIcon from "../../assets/icons/viewMorePlainIcon.svg";

const OverviewEstadoResultados: FC = () => {
  const classes = useStyles();
  const { getDashboardMaster, dashboardMaster, getTradeByBusiness } =
    useIndicators();
  const isMountedRef = useIsMountedRef();
  const { user } = useAuth();
  const [info, setInfo] = useState<any>();
  const [openTable, setOpenTable] = useState(false);
  const [valueUtilidadNeta, setValueUtilidadNeta] = useState({});
  const { t } = useTranslation('dashboard');
  const date = new Date();
  let nextDate = new Date(date)
  nextDate.setFullYear(date.getFullYear() +1)
  const utc = date.getTime() + date.getTimezoneOffset() * 60000;
  const nd = new Date(utc + 3600000 * -5);
  const now = `${nd.getFullYear()}-${nd.getMonth() + 1}-${nd.getDate()}`;
  const topRef = useRef(null);
  const bottomRef = useRef(null);
  const [goingUp, setGoingUp] = useState(false);
  const [displayAlert, setDisplayAlert] = useState(true);
  const [totalSales, setTotalSales] = useState(0);
  const prevScrollY = useRef(
    topRef.current !== null &&
      topRef.current.getBoundingClientRect() !== undefined
      ? topRef.current.getBoundingClientRect().y
      : 0
  );

  let today = new Date()

  const [valueFromDate, setValueFromDate] = useState(today);
  const [valueToDate, setValueToDate] = useState(addDays(valueFromDate, 6));
  const [tablaData, setTablaData] = useState({header: ["No hay datos para la fecha seleccionada"], rows: []});
  const [smallTableData, setSmallTableData] = useState({header: ["No hay datos para la fecha seleccionada"], rows: []});
  const [utilityGraph, setUtilityGraph] = useState({header: ["No hay datos para la fecha seleccionada"], tableData: []});
  const [cashFlowTable, setCashFlowTable] = useState([
    { name: 'Costos de Venta y Producción', value: 0 },
    { name: 'Utilidad Bruta', value: 0 },
    { name: 'Utilidad Neta', value: 0 },
  ]);
  const [expensesTable, setExpensesTable] = useState([
    { name: 'Gastos de Ventas', value: 0 },
    { name: 'Gastos Administrativos', value: 0 },
    { name: 'Gastos Financieros', value: 0 },
    { name: 'Gastos No Operacionales', value: 0 },
    { name: 'Total Gastos', value: 0 },
  ]);
  const [dataIfDonuts, setDataIfDonuts] = useState({
    retorno: 0,
    retornoCapital: 0,
    roa: 0,
    ebitda: 0,
  })
  const [noInfo, setNotInfo] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const executeScroll = () => {
    if (goingUp) {
      if (topRef.current === null) return;
      topRef.current.scrollIntoView();
      setGoingUp(false);
    } else if (!goingUp) {
      if (bottomRef.current === null) return;
      bottomRef.current.scrollIntoView();
      setGoingUp(true);
    }
  };

  const handleScroll = () => {
    if (topRef.current === null) return;
    const currentScrollY = topRef.current.getBoundingClientRect().y;
    if (prevScrollY.current < currentScrollY && goingUp) {
      setGoingUp(false);
    }
    if (prevScrollY.current > currentScrollY && !goingUp) {
      setGoingUp(true);
    }
    prevScrollY.current = currentScrollY;
  };

  const handleOpenTable = (newValue) => {
    setOpenTable(prevState => !prevState);
  };

  const EtlStatus = async () => {
    try {
      if (user['rolDesc'] === 'master' || user['rolDesc'] === 'estandar') {
        const obj = {
          businessId: user.businessId.business_id,
          date: now,
        };
        await getDashboardMaster();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onIdle = () => {
    window.location.reload();
  };

  const compareDate = (date) => new Date(date.setHours(0,0,0,0))

  const handleOnDateFromChange = (date: any) => {
    // const newDate = new Date(date)
    // const newDateMonth = newDate.getMonth() +1
    // const newDateDay = newDate.getDate() 
    // const newDateYear = newDate.getFullYear() 
    // const newDateFormatted = `${newDateMonth < 10 ? '0' + newDateMonth : newDateMonth}/${newDateDay < 10 ? '0' + newDateDay : newDateDay}/${newDateYear}`
    

    // const newDate = new Date(date)
    // const newDateMonth = newDate.getMonth() +1
    // const newDateDay = newDate.getDate() 
    // const newDateYear = newDate.getFullYear() 
    // const newDateFormatted = `${newDateMonth < 10 ? '0' + newDateMonth : newDateMonth}/${newDateDay < 10 ? '0' + newDateDay : newDateDay}/${newDateYear}`

    if(compareDate(date) <= compareDate(valueToDate)){
      setValueFromDate(date);
    }else{
      setDialogContent({title: "Error en Fecha Desde", content: '"Fecha Desde" debe ser menor o igual a "Fecha Hasta"'})
      setOpen(true)
    }
  };

  const handleOnDateToChange = (date: any) => {
    console.log("valueFromDate", valueFromDate)
    console.log("date", date)
    if(compareDate(date) >= compareDate(valueFromDate)){
      setValueToDate(date);
    }else{
      setDialogContent({title: "Error en Fecha Hasta", content: '"Fecha Hasta" debe ser mayor o igual a "Fecha Desde"'})
      setOpen(true)
    }
    
  };

  const buildExpensesTable = (data: any) => {
    let tempTable = [];
    let tempTableExpenses = [];
    // console.log(data);
    for (let row of data.rows) {
      if (row.data[0] === "Utilidad Neta (UN)" || row.data[0] === "Utilidad Bruta" || row.data[0] === "Costos de Venta y Produccion") {
        const [, ...restOfData] = row.data;
        let sum = 0;
        restOfData.map(data => {
          sum += data;
        })
        const tempRow = {
          name: row.data[0],
          value: sum
        }
        tempTable.push(tempRow);
      } else if (row.data[0] === "Ventas Totales") {
        const [, ...restOfData] = row.data;
        let sum = 0;
        restOfData.map(data => {
          sum += data;
        })
        const totalSaleIncome = sum;
        setTotalSales(totalSaleIncome);
      } else if (row.data[0] === "Gastos") {
        const [, ...restOfData] = row.data;
        let sum = 0;
        restOfData.map(data => {
          sum += data;
        })
        let tempRow = {
          name: `Total ${row.data[0]}`,
          value: sum
        };
        tempTableExpenses.push(tempRow);
        const subrows = row.subRows;
        subrows.map(subData => {
          if (subData.data[0] === "Gastos No Operacionales") {
            const [, ...restOfData] = subData.data;
            let sum = 0;
            restOfData.map(data => {
              sum += data;
            })
            tempRow = {
              name: subData.data[0],
              value: sum
            };
            tempTableExpenses.push(tempRow);
          }
          if (subData.data[0] === "Gastos de Actividades Ordinarias") {
            const actOrdinarias = subData.subRows;
            actOrdinarias.map( actividades => {
              if (actividades.data[0] === "Gastos de Ventas" || actividades.data[0] === "Gastos Administrativos" ||
                  actividades.data[0] === "Gastos Financieros" ) {
                const [, ...restOfData] = actividades.data;
                let sum = 0;
                restOfData.map(data => {
                  sum += data;
                })
                tempRow = {
                  name: actividades.data[0],
                  value: sum
                };
                tempTableExpenses.push(tempRow);
              }
            })
          }
        })
      }
    }
    setCashFlowTable(tempTable);
    setExpensesTable(currentExpenses =>
        currentExpenses.map(expense => {
          const matchingExpense = tempTableExpenses.find(tempExpense => tempExpense.name === expense.name);
          return matchingExpense ? { ...expense, value: matchingExpense.value } : expense;
        })
    );
  };

  const buildGraph = async (data) => {
    const fechaBase = new Date(valueFromDate);
    const length = data.header.length;
    let datesArray = [];
    let tempData = [];
    let tempDataUtilidad = [];
    let tempResEjercicio = [];
    for (let i = 0; i < length; i++) {
      let futureDate = new Date(fechaBase.getFullYear(), fechaBase.getMonth(), fechaBase.getDate() + i);
      datesArray.push(futureDate.getTime()); // No division by 1000, to get milliseconds
    }
    await Promise.all(data.rows.map(async (row) => {
      if (row.data[0] === "Utilidad Despues de Impuestos (EB)") {
        const [, ...restOfData] = row.data;
        // console.log(restOfData);
        datesArray.map((date,index) => {
          const tempDateData = [date, restOfData[index]];
          tempData.push(tempDateData);
        })
      }
      if (row.data[0] === "Utilidad Neta (UN)") {
        const [, ...restOfData] = row.data;
        datesArray.map((date,index) => {
          const tempDateData = [date, restOfData[index]];
          tempDataUtilidad.push(tempDateData);
        })
      }
      if (row.data[0] === "Resultado del Ejercicio") {
        const [, ...restOfData] = row.data;
        datesArray.map((date,index) => {
          const tempDateData = [date, restOfData[index]];
          tempResEjercicio.push(tempDateData);
        })
      }
    }));
    let formatData = [];
    let formatDataUtilidad = [];
    let formatResEjercicio = [];
    tempData.map(([timestamp, value]) => {
      let formatVal = value.toFixed(2);
      let nVal = [
        timestamp,
        new Intl.NumberFormat('en-US', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(value)
      ];
      let newVal = [
        timestamp,
        parseFloat(formatVal)
      ];
      formatData.push(newVal);
    });
    tempDataUtilidad.map(([timestamp, value]) => {
      let formatVal = value.toFixed(2);
      let nVal = [
        timestamp,
        new Intl.NumberFormat('en-US', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(value)
      ];
      let newVal = [
        timestamp,
        parseFloat(formatVal)
      ];
      formatDataUtilidad.push(newVal);
    });

    tempResEjercicio.map(([timestamp, value]) => {
      let formatVal = value.toFixed(2);
      let nVal = [
        timestamp,
        new Intl.NumberFormat('en-US', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(value)
      ];
      let newVal = [
        timestamp,
        parseFloat(formatVal)
      ];
      formatResEjercicio.push(newVal);
    });
    const utilidadesData = {
      utilidadDespImp: formatData,
      utilidadNeta: formatDataUtilidad,
      resEjercicio: formatResEjercicio,
    }
    return utilidadesData;
  }

  const buildUtilityGraph = (data) => {
    console.log("dataUtilityGraph", data)
    const header = [];
    const tableData = [];
    let totalVentas = 0;
    let totalUBruta = 0;
    let totalUEBITDA = 0;

    let totalUEBIT = 0;
    let totalUEBT = 0;
    let totalUEB = 0;
    let totalUN = 0;
    data.rows.map(row => {
      if (row.data[0] === "Ventas Totales") {
        const [, ...restOfData] = row.data;
        restOfData.map(venta => {
          if(venta){
            totalVentas = totalVentas + venta;

          }
        });
      }
      if (row.data[0] === "Utilidad Bruta") {
        const [, ...restOfData] = row.data;
        restOfData.map(uB => {
          if(uB){
            totalUBruta = totalUBruta + uB;

          }
        });
        const porcentajeUB = Math.round((totalUBruta/totalVentas)*100);
        header.push("Utilidad Bruta (GI)");
        tableData.push(porcentajeUB);

      }

      if (row.data[0] === "Utilidad Bruta (EBITDA)") {
        const [, ...restOfData] = row.data;
        restOfData.map(uB => {
          if(uB){
            totalUEBITDA = totalUEBITDA + uB;

          }
        });
        const porcentajeUEBITDA = Math.round((totalUEBITDA/totalVentas)*100);
        header.push("Utilidad Bruta (EBITDA)");
        tableData.push(porcentajeUEBITDA);
      }
      if (row.data[0] === "Utilidad Bruta (EBIT)") {
        const [, ...restOfData] = row.data;
        restOfData.map(uB => {
          if(uB){
          totalUEBIT = totalUEBIT + uB;}
        });
        const porcentajeUEBIT = Math.round((totalUEBIT/totalVentas)*100);
        header.push("Utilidad Bruta (EBIT)");
        tableData.push(porcentajeUEBIT);
      }
      if (row.data[0] === "Utilidad Despues de Intereses (EBT)") {
        const [, ...restOfData] = row.data;
        restOfData.map(uB => {
          if(uB){
          totalUEBT = totalUEBT + uB;}
        });
        const porcentajeUEBT = Math.round((totalUEBT/totalVentas)*100);
        header.push("Utilidad Despues de Intereses (EBT)");
        tableData.push(porcentajeUEBT);
      }
      if (row.data[0] === "Utilidad Despues de Impuestos (EB)") {
        const [, ...restOfData] = row.data;
        restOfData.map(uB => {
          if(uB){
          totalUEB = totalUEB + uB;}
        });
        const porcentajeUEB = Math.round((totalUEB/totalVentas)*100);
        header.push("Utilidad Despues de Impuestos (EB)");
        tableData.push(porcentajeUEB);
      }
      if (row.data[0] === "Utilidad Neta (UN)") {
        const [, ...restOfData] = row.data;
        restOfData.map(uB => {
          if(uB){
          totalUN = totalUN + uB;
          }
        });
        const porcentajeUN = Math.round((totalUN/totalVentas)*100);
        header.push("Utilidad Neta (NI)");
        tableData.push(porcentajeUN);
      }
    })
    
    const graphData = {
      header: header,
      tableData: tableData
    }
    console.log("graphData", graphData)
    setUtilityGraph(graphData);
  }


  const buildZazacorpTableJsonBg = async (data) => {
    //console.log("data", data)
    // Identificar todos los encabezados de fecha únicos en los datos
    let headerDates = [];
    data.forEach(item => {
      Object.keys(item).forEach(key => {
        const parts = key.split('_');
        if (parts.length === 2 && !isNaN(Number(parts[1]))) {
          if (!headerDates.includes(key)) {
            headerDates.push(key);
          }
        }
      });
    });


    //console.log("headerdatesbg", headerDates)

    // headerDates.sort(); // Para ordenar las fechas

    // Transformar las claves de fecha en fechas formateadas
    // const fechaBase = new Date(data[0].fecha_desde);
    const fechaBase = new Date(valueFromDate);
    let currentDate = fechaBase;
    const formattedDates = headerDates.map((date, index) => {
      if (index === 0) {
        return "Hoy"; // Primer encabezado como 'Today'
      }
      const day = parseInt(date.split('_')[1], 10);
      const newDate = addDays(currentDate, 1);
      currentDate = newDate;
      return `${newDate.getDate().toString().padStart(2, '0')}/${(newDate.getMonth() + 1).toString().padStart(2, '0')}/${newDate.getFullYear()}`;
    });

    //console.log("formattedDatesbg", formattedDates)


    // Crear un mapa para mantener referencias a las filas basadas en índices
    const indexToRowMap = new Map();

    // Crear la estructura de filas y subfilas
    const rows = [];

    data.forEach(item => {
        const rowData = [item.name, ...headerDates.map(date => item[date] === null ? 0 : item[date])];

        //console.log("rowDataBg", rowData)

        const indexParts = item.index.split('.');
        const row = { data: rowData, subRows: [] };
        indexToRowMap.set(item.index, row);

        rows.push(row)
    });

    return {header: formattedDates, rows};
  };

  const buildZazacorpTableJson = async (data) => {
    //console.log("dataEr", data)
    // Identificar todos los encabezados de fecha únicos en los datos
    let headerDates = [];
    data.forEach(item => {
      Object.keys(item).forEach(key => {
        const parts = key.split('_');
        if (parts.length === 2 && !isNaN(Number(parts[1]))) {
          if (!headerDates.includes(key)) {
            headerDates.push(key);
          }
        }
      });
    });

    // headerDates.sort(); // Para ordenar las fechas

    // Transformar las claves de fecha en fechas formateadas
    // const fechaBase = new Date(data[0].fecha_desde);
    const fechaBase = new Date(valueFromDate);
    let currentDate = fechaBase;
    const formattedDates = headerDates.map((date, index) => {
      if (index === 0) {
        return "Hoy"; // Primer encabezado como 'Today'
      }
      const day = parseInt(date.split('_')[1], 10);
      const newDate = addDays(currentDate, 1);
      currentDate = newDate;
      return `${newDate.getDate().toString().padStart(2, '0')}/${(newDate.getMonth() + 1).toString().padStart(2, '0')}/${newDate.getFullYear()}`;
    });


    // Crear un mapa para mantener referencias a las filas basadas en índices
    const indexToRowMap = new Map();

    // Crear la estructura de filas y subfilas
    const rows = [];

    data.forEach(item => {
        const rowData = [item.name, ...headerDates.map(date => item[date] === null ? 0 : item[date])];
        
        const indexParts = item.index.split('.');
        const row = { data: rowData, subRows: [] };
        indexToRowMap.set(item.index, row);

        if (indexParts.length === 1) {
            // Es una categoría principal
            rows.push(row);
        } else {
            // Es una subcategoría
            const parentIndex = indexParts.slice(0, -1).join('.');
            const parentRow = indexToRowMap.get(parentIndex);
            if (parentRow) {
                parentRow.subRows.push(row);
            }
        }
    });

    return {header: formattedDates, rows};
  };

  const buildSmallTable = async (data) => {
    const tmpHeaders = data.header.slice(0,4);
    const tmpRows = [];
    data.rows.map(row => {
      const tmpSubRow = [];
      if (row.subRows.length > 0) {
        const subRows = row.subRows;
        subRows.map(subrow => {
          const tmpSubRowData = subrow.data.slice(0,5);
          const tempSubSubRows = [];
          if (subrow.subRows.length > 0) {
            const subSubRows = subrow.subRows;
            subSubRows.map(subSubRow => {
              const tmpSubSubRowData = subSubRow.data.slice(0,5);
              const tempSub3Rows = [];
              if (subSubRow.subRows-length > 0) {
                const sub3Rows = subSubRow.subRows;
                sub3Rows.map(sub3Row => {
                  const tmpSub3RowData = sub3Row.data.slice(0,5);
                  const newSub3Row = {
                    data: tmpSub3RowData,
                    subRows: [],
                  }
                  tempSub3Rows.push(newSub3Row);
                });
                const newSubSubRow = {
                  data: tmpSubSubRowData,
                  subRows: tempSub3Rows
                }
                tempSubSubRows.push(newSubSubRow);
              }
            })
          }
          const newSubRow = {
            data: tmpSubRowData,
            subRows: tempSubSubRows
          }
          tmpSubRow.push(newSubRow);
        });
      }
      const tmpRowData = row.data.slice(0,5);
      const newRow = {
        data: tmpRowData,
        subRows: tmpSubRow
      }
      tmpRows.push(newRow);
    })
    return {
      header: tmpHeaders,
      rows: tmpRows
    }
  };


  
  async function getPredictions() {
    try {
      setIsLoading(true);
      const year = valueFromDate.getFullYear();
      const month = String(valueFromDate.getMonth() + 1).padStart(2, '0');
      const day = String(valueFromDate.getDate()).padStart(2, '0');
      const formattedFromDate = `${year}-${month}-${day}`;
      //const formattedFromDate = valueFromDate.toISOString().split('T')[0];

      const yearToDate = valueToDate.getFullYear();
      const monthToDate = String(valueToDate.getMonth() + 1).padStart(2, '0');
      const dayToDate = String(valueToDate.getDate()).padStart(2, '0');
      const formattedToDate = `${yearToDate}-${monthToDate}-${dayToDate}`;
      
      //const formattedToDate = valueToDate.toISOString().split('T')[0];
      let todayDate = new Date()
      console.log("todayDate", todayDate)
      // todayDate.setDate(todayDate.getDate() + 1)
      const yearTodayDate = todayDate.getFullYear();
      const monthTodayDate = String(todayDate.getMonth() + 1).padStart(2, '0');
      const dayTodayDate = String(todayDate.getDate()).padStart(2, '0');
      const formattedTodayDate = `${yearTodayDate}-${monthTodayDate}-${dayTodayDate}`;


      console.log("todayDate", todayDate)
      const response = await getZazacorpPrediction(formattedFromDate,formattedToDate, 'er_predict');
      const responseBg = await getZazacorpPrediction(formattedFromDate,formattedToDate, 'bg_predict');
      const responseIf = await getZazacorpPrediction(formattedTodayDate,formattedTodayDate,'if_predict');
      const tableJsonIf = await buildZazacorpTableJson(responseIf.resultRangeDates);

     

      console.log("tableJsonIf", tableJsonIf)

      
      // console.log('bg_prediction response', response1);
      const tableJson = await buildZazacorpTableJson(response.result7Days).then(async r => {
        setTablaData(r);
        //console.log("tableJson", r)
        const newSmallTable = await buildSmallTable(r);
        setSmallTableData(newSmallTable);
      });

      const operacionales = tableJsonIf.rows.filter(row => row.data[0] === "Indices Operacionales")[0].subRows;
      const rentabilidad = tableJsonIf.rows.filter(row => row.data[0] === "Indices de Rentabilidad")[0].subRows;
      const gmroiBreakup = tableJsonIf.rows.filter(row => row.data[0] === "GRMROI break-up")[0].subRows;
      

      const tempOperacional = {
              retorno: parseFloat((gmroiBreakup.filter(row => row.data[0] === "GMROI (1)*(2)*(3)")[0].data[1]).toFixed(2)),
            };

      
            
            const tempRentabilidad = {
              retornoCapital: parseFloat((rentabilidad.filter(row => row.data[0] === "Retorno del Capital (1)*(2)*(3)")[0].data[1] * 100).toFixed(2)),
              roa: parseFloat((rentabilidad.filter(row => row.data[0] === "Retorno de Activos (ROA) (utilidad neta/total activos))")[0].data[1] * 100).toFixed(2)),
              ebitda: parseFloat((rentabilidad.filter(row => row.data[0] === "Retorno de Activos (EBITDA/activos totales)")[0].data[1] * 100).toFixed(2)),
            };


      console.log("tempRentabilidad", tempRentabilidad)
      console.log("tempOperacional", tempOperacional)
      

      setDataIfDonuts({...tempOperacional, ...tempRentabilidad})

      const dataTableJson = await buildZazacorpTableJson(response.resultRangeDates);
      //console.log("dataTableJson",dataTableJson)
      buildExpensesTable(dataTableJson);
      const graphTableJson = await buildZazacorpTableJson(response.resultUntilEndYear);
      console.log("graphTablejson", graphTableJson)
      let ejercicioRes = responseBg.resultUntilEndYear.filter(i => i.name === "Resultado del Ejercicio")
      //ejercicioRes[0].parentcode = null
      ejercicioRes = await buildZazacorpTableJsonBg(ejercicioRes)
       console.log("ejercicioRes",ejercicioRes)
      graphTableJson.rows.push(ejercicioRes.rows[0])
      buildUtilityGraph(graphTableJson);
      // console.log("utilityGraphData", utilityGraph)
      // console.log("graphtablejsonn", graphTableJson)
      let graphTableJsons = []
      // for (let i = 0; i < 12; i++) {
      //   const element = graphTableJson.rows[i];

      //   graphTableJsons.push(element)
      // }
     // graphTableJsons.push(graphTableJson.rows[graphTableJson.rows.length - 1])
      const utilidadesData = await buildGraph(graphTableJson).then(r => {
        console.log("utildiadesData", r)
        r.utilidadNeta = r.utilidadNeta.slice(0,-2)
        r.resEjercicio = r.resEjercicio.slice(0,-2)
        console.log("utildiadesData", r)
        if(Object.keys(valueUtilidadNeta).length === 0){
          setValueUtilidadNeta(r);

        }
      });
      setNotInfo(false);
      setIsLoading(false);
    } catch (e) {
      console.log(e);
      setIsLoading(false);
      setNotInfo(true);
    }
  }

  

  useEffect(() => {
    EtlStatus();
  }, []);

  useEffect(() => {
    setInfo(dashboardMaster);
  }, [dashboardMaster]);

  useEffect(() => {
    window.addEventListener('wheel', handleScroll);

    return () => window.removeEventListener('wheel', handleScroll);
  }, [goingUp]);

  useEffect(() => {
    getPredictions();
  }, [valueFromDate, valueToDate]);

  const [open, setOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState({title: "", content: ""})


  const handleClose = () => {
    setOpen(false);
  };

  return (
  <Box 
    sx={{
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh", // Full viewport height
      backgroundColor: "background.default",
    }}
  >

    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {dialogContent.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {dialogContent.content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          
          <Button onClick={handleClose} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    
    <Box sx={{ flexGrow: 1, paddingTop: 2 }}> {/* Content expands */}
      <Container maxWidth={false}>
        <Grid container justifyContent="space-between">
          <Grid item xs={12} md={12} mb={1}>
            <Collapse in={displayAlert}>
              <Alert 
                severity="warning" 
                variant="outlined" 
                sx={{ bgcolor: "background.paper", color: "#034787" }} 
                onClose={() => setDisplayAlert(false)}
              >
                Se proyecta para la fecha {now} una 
                <span style={{ fontWeight: "bold", fontSize: "1.05rem" }}>
                  {" "}disminución en la utilidad neta (UN) por $3,815.43
                </span>.
              </Alert>
            </Collapse>
          </Grid>
          
          <Grid item xs={12} md={7} display="flex" alignItems="center" sx={{ paddingTop: "5px" }}>
            <AssessmentIcon sx={{ color: "#001930" }} fontSize="medium" />
            <Typography sx={{ paddingLeft: 1, fontWeight: 700, fontSize: "1.625rem" }} color="textSecondary">
              Estado de Resultados Proforma
            </Typography>
            <Box ml={1} onClick={() => handleOpenTable(true)} sx={{ cursor: "pointer", alignSelf: "end" }}>
              <img src={viewMoreIcon} alt="costos x ventas" width="35px" height="35px" />
            </Box>
          </Grid>

          {/* Date Pickers */}
          <Grid item xs={12} md={5}>
            <Grid container>
              <Grid item xs={12} md={6} display="flex" alignItems="center">
                <Typography color="#42526E" fontWeight={500} mr={1} width="50%" display="flex" justifyContent="end">
                  Fecha Desde
                </Typography>
                <DatePicker 
                  selected={valueFromDate} 
                  minDate= {new Date()}
                  maxDate= {nextDate}
                  locale="es" 
                  onChange={handleOnDateFromChange} 
                  dateFormat="yyyy-MM-dd" 
                  className={classes.datePicker} 
                  popperClassName={classes.datePickerPopper} 
                />
              </Grid>
              <Grid item xs={12} md={6} display="flex" alignItems="center">
                <Typography color="#42526E" fontWeight={500} mr={1} width="50%" display="flex" justifyContent="end">
                  Fecha Hasta
                </Typography>
                <DatePicker 
                  selected={valueToDate} 
                  locale="es" 
                  minDate= {new Date()}
                  maxDate = {nextDate}
                  onChange={handleOnDateToChange} 
                  dateFormat="yyyy-MM-dd" 
                  className={classes.datePicker} 
                  popperClassName={classes.datePickerPopper} 
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Loading Indicator */}
          {isLoading ? (
            <Grid item xs={12} md={12} pt={10} display="flex" justifyContent="center">
              <CircularProgress />
            </Grid>
          ) : (
            <>
              {openTable ? (
                <Grid item xs={12} pt={2}>
                  <div ref={bottomRef}>
                    <TablaFinanciera data={tablaData} openTable={handleOpenTable} title="Estado de Resultados" />
                  </div>
                </Grid>
              ) : (
                <>
                  <Grid item xs={12} md={12} display="flex">
                    <Grid item xs={12} md={4} padding={1} height="175px">
                      <TotalSalesIncome data={totalSales}/>
                    </Grid>
                    <Grid item xs={12} md={4} padding={1} height="175px">
                      <WidgeTwoColumns data={cashFlowTable} />
                    </Grid>
                    <Grid item xs={12} md={4} padding={1}>
                      <WidgetBalance data={expensesTable} />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <ChartUtilidadNeta data={valueUtilidadNeta} />
                  </Grid>
                  {/* <Grid container spacing={1} xs={12} pt={2}>
                    <Grid item xs={12} md={6}>
                      <BarDonutER info={dataIfDonuts}/>
                      
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <UtilitiesRadialBars data={utilityGraph}/>
                    </Grid>
                  </Grid> */}
                  <Grid spacing={1} xs={12} pt={2} container direction="row" >
                  {/* First Column */}
                  <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Box sx={{ flexGrow: 1 }}>
                      {/* This will grow with the height of the second column */}
                      <BarDonutER info={dataIfDonuts}/>
                    </Box>
                  </Grid>

                  {/* Second Column */}
                  <Grid item xs={6}>
                    <Box sx={{  }}>
                      {/* Simulate a tall component */}
                          <UtilitiesRadialBars data={utilityGraph}/>

                    </Box>
                  </Grid>
                </Grid>
                </>
              )}
            </>
          )}
        </Grid>
      </Container>
    </Box>

    {/* Footer (Always at Bottom) */}
    <Box component="footer" sx={{ py: 2, px: 3}}>
      <Typography sx={{ fontSize: '1rem' }}>© 2025 Dynamics Within. Todos los Derechos Reservados.</Typography>
    </Box>
  </Box>
);
};

export default OverviewEstadoResultados;
